export const APP_STATES = {
  normal: 0,
  restoration: 1,
  maintenance: 2,
  down: 3,
} as const;

export type AppStateValue = typeof APP_STATES[keyof typeof APP_STATES];
type Subscriber = (value: AppStateValue) => void;

export class GlobalState {
  private value: AppStateValue;

  private subscribers = new Set<Subscriber>();

  constructor(initialValue: AppStateValue) {
    this.value = initialValue;
  }

  getValue(): AppStateValue {
    return this.value;
  }

  setValue(newState: AppStateValue): void {
    if (this.value === newState) return;
    this.value = newState;
    this.subscribers.forEach((fn) => fn(this.value));
  }

  subscribe(fn: Subscriber): void {
    this.subscribers.add(fn);
  }

  unsubscribe(fn: Subscriber): void {
    this.subscribers.delete(fn);
  }
}

export const AppState = new GlobalState(APP_STATES.normal);
